export enum SupplyDemandStatus {
  /**
   * 待审核
   */
  WAIT_AUDIT = 0,
  /**
   * 审核通过
   */
  AUDIT_SUCCESS = 1,
  /**
   * 审核失败
   */
  AUDIT_FAIL = 2
}
